// @ts-nocheck
import { useStore } from 'effector-react';
import { $isDesktop } from 'models/device-params-model';
import { useTranslation } from 'react-i18next';

const expressions = require('angular-expressions');

const throwResourcesError = (text) => {
    console.warn(`MyAdvocate resources error:\n\n${text}`);
};

const throwMissingAdjustedResources = (arg1, screenSizeKey, screenAdjustedResult) => {
    throwResourcesError(
        `${arg1} is missing a translation for ${screenSizeKey}. Found only ${Object.keys(screenAdjustedResult ?? {})
            ?.map?.((i) => `"${i}"`)
            ?.join?.(', ')}`,
    );
};

const useResources = (...props) => {
    const resources = useTranslation(...props);
    const { t } = resources;
    const isDesktop = useStore($isDesktop);
    const screenSizeKey = isDesktop ? 'desktop' : 'mobile';

    const modifiedT = (arg1?: any, arg2?: any, arg3?: any) => {
        const result = t(arg1, arg2, arg3);
        if (result?.includes?.(`returned an object instead of string`)) {
            const screenAdjustedResult = t(arg1, { ...(arg2 ?? {}), returnObjects: true }, arg3);
            if (!screenAdjustedResult?.[screenSizeKey]) {
                throwMissingAdjustedResources(arg1, screenSizeKey, screenAdjustedResult);
            }
            return screenAdjustedResult?.[screenSizeKey] ?? arg1;
        }
        return result;
    };

    const evaluate = (expression: string, scope: object) => {
        try {
            return expressions.compile(expression.replace(/{{ /g, '').replace(/ }}/g, ''))(scope) || expression;
        } catch (e) {
            return expression;
        }
    };

    return { ...resources, t: modifiedT, evaluate };
};

export default useResources;
